async function responseHandler(request, toast, setErrors: any = null) {
	return await new Promise((resolve, reject) => {
		request
			.then((res) => {
				if (res.status === 200) {
					resolve(res.data);
				}
			})
			.catch((error) => {
				if (error.response.status === 400) {
					toast.error('Invalid', error.response.data);
				} else {
					toast.error('Error', error.response.data);
				}

				reject(error);
			});
	});
}

export default responseHandler;
